import { render, staticRenderFns } from "./language-select.vue?vue&type=template&id=98d6d6b8&scoped=true&"
import script from "./language-select.vue?vue&type=script&lang=js&"
export * from "./language-select.vue?vue&type=script&lang=js&"
import style0 from "./language-select.vue?vue&type=style&index=0&id=98d6d6b8&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d6d6b8",
  null
  
)

export default component.exports